import { createFileRoute } from "@tanstack/react-router";
import { FamilyHomePage } from "@/components/app/portal/pages/family-home-page";

export const Route = createFileRoute("/family-portal/")({
  head: () => ({ meta: [{ title: "Family portal | People AI" }] }),
  component: FamilyHomePage,
});
